import { Type } from 'class-transformer';
import { Model } from './model';
import { User } from './user';

export class Note extends Model {
  id: string;

  content: string;

  pinned: boolean;

  author_id: string | null;

  @Type(() => User)
  author: User | null;

  partner_id: string;
}
